import {
    FETCH_DAILY_STRESS_DATA_REPORTS,
    FETCH_DAILY_STRESS_DATA_REPORTS_FETCHING,
    FETCH_DAILY_STRESS_DATA_REPORTS_SUCCESS,
    FETCH_DAILY_STRESS_DATA_REPORTS_FAIL,
    FETCH_WEEKLY_STRESS_DATA_REPORTS,
    FETCH_WEEKLY_STRESS_DATA_REPORTS_FETCHING,
    FETCH_WEEKLY_STRESS_DATA_REPORTS_SUCCESS,
    FETCH_WEEKLY_STRESS_DATA_REPORTS_FAIL
} from '../../actions/stressActions';
import { RESET_PROFILE_PAGE } from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    dailyStressData: [],
    dailyStressDataFetching: false,
    dailyStressDataFetchFail: false,
    weeklyStressData: [],
    weeklyStressDataFetching: false,
    weeklyStressDataFetchFail: false
};

// ======= Daily Fetching Handlers =======
const fetchDailyStressDataFetching = (state) => {
    return {
        ...state,
        dailyStressDataFetching: true,
        dailyStressDataFetchFail: false
    };
};

const fetchDailyStressDataSuccess = (state, action) => {
    return {
        ...state,
        dailyStressData: action.dailyStressData,
        dailyStressDataFetching: false,
        dailyStressDataFetchFail: false
    };
};

const fetchDailyStressDataFail = (state) => {
    return {
        ...state,
        dailyStressDataFetching: false,
        dailyStressDataFetchFail: true
    };
};

// ======= Weekly Fetching Handlers =======
const fetchWeeklyStressDataFetching = (state) => {
    return {
        ...state,
        weeklyStressDataFetching: true,
        weeklyStressDataFetchFail: false
    };
};

const fetchWeeklyStressDataSuccess = (state, action) => {
    return {
        ...state,
        weeklyStressData: action.weeklyStressData,
        weeklyStressDataFetching: false,
        weeklyStressDataFetchFail: false
    };
};

const fetchWeeklyStressDataFail = (state) => {
    return {
        ...state,
        weeklyStressDataFetching: false,
        weeklyStressDataFetchFail: true
    };
};

const resetToInitialState = () => INITIAL_STATE;

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DAILY_STRESS_DATA_REPORTS_FETCHING]: fetchDailyStressDataFetching,
    [FETCH_DAILY_STRESS_DATA_REPORTS_SUCCESS]: fetchDailyStressDataSuccess,
    [FETCH_DAILY_STRESS_DATA_REPORTS_FAIL]: fetchDailyStressDataFail,
    [FETCH_WEEKLY_STRESS_DATA_REPORTS_FETCHING]: fetchWeeklyStressDataFetching,
    [FETCH_WEEKLY_STRESS_DATA_REPORTS_SUCCESS]: fetchWeeklyStressDataSuccess,
    [FETCH_WEEKLY_STRESS_DATA_REPORTS_FAIL]: fetchWeeklyStressDataFail,
    [RESET_PROFILE_PAGE]: resetToInitialState
};

// ======= Default Action ======
export default function stressDataReports(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchDailyStressData(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_DAILY_STRESS_DATA_REPORTS,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function fetchWeeklyStressData(payload, evictCache) {
    return {
        type: FETCH_WEEKLY_STRESS_DATA_REPORTS,
        payload: payload,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

// ======= Selectors =======
export const getDailyStressData = (state) => {
    return state.stressDataReports.dailyStressData ? state.stressDataReports.dailyStressData : null;
};

export const isDailyStressDataFetching = (state) => {
    return state.stressDataReports.dailyStressDataFetching;
};

export const didDailyStressDataFetchFail = (state) => {
    return state.stressDataReports.dailyStressDataFetchFail;
};

export const getWeeklyStressData = (state) => {
    return state.stressDataReports.weeklyStressData ? state.stressDataReports.weeklyStressData : null;
};

export const isWeeklyStressDataFetching = (state) => {
    return state.stressDataReports.weeklyStressDataFetching;
};

export const didWeeklyStressDataFetchFail = (state) => {
    return state.stressDataReports.weeklyStressDataFetchFail;
};
